window.addEventListener("load", function(){
      var scroll = new SmoothScroll('a[href^="#"]');
  
      const menu = document.querySelectorAll(".js-menu");
 
      function toggle() {
        
        const content = this.nextElementSibling;
        this.classList.toggle("is-active");
        content.classList.toggle("is-open");
      }
 
      for (let i = 0; i < menu.length; i++) {
        menu[i].addEventListener("click", toggle);
      }
});

window.onload = ()=> {
  let url = location.pathname;
  const brand = document.getElementById("snize_filters_block_vendor");
  
  if (url == "/collections/russell-hobbs" | url == "/collections/cores" | url == "/collections/dunnetts" | url == "/collections/mat-black-series" | url == "/collections/basic-series") {
    brand.style.display ="none";
  } 
}
